"use strict";

(function ($) {
  $.fn.dropdown = function () {
    $(this).on('click', function (e) {
      e.stopPropagation();
      $(this).closest('.js-dropdown').toggleClass('is-open');
    });
    $(document).on("click", function (e) {
      if ($(e.target).closest(".js-dropdown").length || $(e.target).is(".js-dropdown")) {} else {
        $('.js-dropdown').removeClass('is-open');
      }
    });
  };
})(jQuery);

$(function () {
  if ($('.js-dropdown-open').length) {
    $('.js-dropdown-open').dropdown();
  }
});